<div class="main-box" *transloco="let t; prefix: 'fuelDashboard'">
  <div class="top-title">
    <h2>{{ t('modals.reconciliationVariateBreakdown.title') }}</h2>
    <button type="button" (click)="closeModal()">
      <img src="assets/images-fuel/closeModalBtnIcon.svg" alt="icon-close" />
    </button>
  </div>
  <div class="inner-body">
    <div class="inner-row">
      <div class="row-left">
        <div class="card">
          <h3>{{ t('modals.reconciliationVariateBreakdown.tableTitle') }}</h3>
          <!-- <app-common-table [modalType]="'reconciliation-variate'"></app-common-table> -->
          <div class="main-table reconciliation-variate">
            <table class="table">
              <thead>
                <tr>
                  <th class="factor">{{ t('table.factor') }}</th>
                  <th class="last-month">{{ t('table.lastMonth') }}</th>
                  <th class="this-month">{{ t('table.thisMonth') }}</th>
                  <th class="change">{{ t('table.change') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="factor">
                    <p class="bold-text">{{ t('modals.reconciliationVariateBreakdown.fuelVariant') }}</p>
                  </td>
                  <td class="last-month">
                    <p>2.5%</p>
                  </td>
                  <td class="this-month">
                    <p>3%</p>
                  </td>
                  <td class="change">
                    <p>+20%</p>
                  </td>
                </tr>
                <tr>
                  <td class="factor">
                    <p class="bold-text">{{ t('modals.reconciliationVariateBreakdown.fuelDiscrepancies') }}</p>
                  </td>
                  <td class="last-month">
                    <p>{{ t('values.cases', { count: 7 }) }}</p>
                  </td>
                  <td class="this-month">
                    <p>{{ t('values.cases', { count: 5 }) }}</p>
                  </td>
                  <td class="change">
                    <p>-28.57%</p>
                  </td>
                </tr>
                <tr>
                  <td class="factor">
                    <p class="bold-text">{{ t('modals.reconciliationVariateBreakdown.totalFuelReported') }}</p>
                  </td>
                  <td class="last-month">
                    <p>{{ t('values.litres', { value: '500 000' }) }}</p>
                  </td>
                  <td class="this-month">
                    <p>{{ t('values.litres', { value: '300 000' }) }}</p>
                  </td>
                  <td class="change">
                    <p>-38%</p>
                  </td>
                </tr>
                <tr>
                  <td class="factor">
                    <p class="bold-text">{{ t('modals.reconciliationVariateBreakdown.fuelPurchasedLitres') }}</p>
                  </td>
                  <td class="last-month">
                    <p>{{ t('values.litres', { value: '520 000' }) }}</p>
                  </td>
                  <td class="this-month">
                    <p>{{ t('values.litres', { value: '310 000' }) }}</p>
                  </td>
                  <td class="change">
                    <p>-48.38%</p>
                  </td>
                </tr>
                <tr>
                  <td class="factor">
                    <p class="bold-text">{{ t('modals.reconciliationVariateBreakdown.unrecordedFuel') }}</p>
                  </td>
                  <td class="last-month">
                    <p>{{ t('values.litres', { value: '20 000' }) }}</p>
                  </td>
                  <td class="this-month">
                    <p>{{ t('values.litres', { value: '10 000' }) }}</p>
                  </td>
                  <td class="change">
                    <p>-50%</p>
                  </td>
                </tr>
                <tr>
                  <td class="factor">
                    <p class="bold-text">{{ t('modals.reconciliationVariateBreakdown.refuelingFrequency') }}</p>
                  </td>
                  <td class="last-month">
                    <p>{{ t('values.refuelsPerTrip', { count: 5 }) }}</p>
                  </td>
                  <td class="this-month">
                    <p>{{ t('values.refuelsPerTrip', { count: 4 }) }}</p>
                  </td>
                  <td class="change">
                    <p>-10%</p>
                  </td>
                </tr>
                <tr>
                  <td class="factor">
                    <p class="bold-text">{{ t('modals.reconciliationVariateBreakdown.avgRouteType') }}</p>
                  </td>
                  <td class="last-month">
                    <p>-</p>
                  </td>
                  <td class="this-month">
                    <p>-</p>
                  </td>
                  <td class="change">
                    <p>-</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="inner-right">
        <div class="card grap-card increase">
          <div class="card-body p-0">
            <div class="grap-up d-flex align-items-center justify-content-between">
              <div class="graph-text">
                <h4>{{ t('widgets.reconciliationVariate') }}</h4>
                <p>
                  15% <strong>+19.29%</strong>
                  <img src="assets/images-fuel/greenArrowIcon.svg" alt="">
                </p>
              </div>
              <div class="button-wrapper">
                <div class="common-drop-down no-filter dropdown">
                  <button type="button" id="dropdown-menu" data-bs-toggle="dropdown" aria-expanded="false">
                    <img src="assets/images-fuel/threeDotBtnIcon.svg" alt="button-icon" />
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="dropdown-menu">
                    <li><a class="dropdown-item">{{ t('units.litres') }}</a></li>
                    <li>
                      <a class="dropdown-item">{{ t('units.litresPerKilometer') }}</a>
                    </li>
                    <li>
                      <a class="dropdown-item">{{ t('units.litresPer100km') }}</a>
                    </li>
                    <li>
                      <a class="dropdown-item">{{ t('units.randsPerLitre') }}</a>
                    </li>
                  </ul>
                </div>
                <button (click)="fullChartClick()" class="full-grap">
                  <img src="assets/images-fuel/grapBtnIcon.svg" alt="graph-icon" />
                </button>
              </div>
            </div>
            <div class="grap-down">
              <app-grouped-bar-chart [data]="reconciliationVariateData"
                [subgroups]="[{name:'Bought', legend: t('charts.fuelBought'), color: '#FF7F00'}, {name:'Detected', legend: t('charts.fuelDetected'), color: '#3873C9'}]"
                [labelKey]="'label'" [yTicks]="[0, 20, 40, 60, 80, 100]" [barWidth]="18.04" [chartHeight]="134"
                [viewMode]="'all'" [exportBtn]="false" [margin]="{ top: 10, right: 0, bottom: 19, left: 35 }" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>